const RequestStatus = Object.freeze({
  Requested: 'Requested',
  PendingClub: 'PendingClub',
  Accepted: 'Accepted',
  Declined: 'Declined',
  Expired: 'Expired',
});

const statusLabel = (status) => {
  switch (status) {
    case RequestStatus.Requested: return 'Submitted';
    case RequestStatus.PendingClub: return 'Awaiting Club';
    case RequestStatus.Accepted: return 'Confirmed';
    case RequestStatus.Declined: return 'Declined';
    case RequestStatus.Expired: return 'Expired';
    default: return 'Unknown';
  }
};

const statusColor = (status) => {
  switch (status) {
    case RequestStatus.Requested: return 'bg-gray-100 text-gray-800 border-gray-300';
    case RequestStatus.PendingClub: return 'bg-yellow-50 text-yellow-800 border-yellow-300';
    case RequestStatus.Accepted: return 'bg-green-50 text-green-800 border-green-300';
    case RequestStatus.Declined: return 'bg-red-50 text-red-800 border-red-300';
    case RequestStatus.Expired: return 'bg-gray-50 text-gray-600 border-gray-200';
    default: return 'bg-gray-50 text-gray-600 border-gray-200';
  }
};

const isTerminal = status => (
  status === RequestStatus.Accepted
  || status === RequestStatus.Declined
  || status === RequestStatus.Expired
);

export {
  RequestStatus,
  statusLabel,
  statusColor,
  isTerminal,
};
